<template>
  <div class="container">
    <div class="sideNav">
      <div class="logo">
        <!-- X.Y.T -->
        <img src="../../assets/logo.png" />
      </div>
      <el-menu background-color="#2e3d4c" text-color="#fff" active-text-color="#409EFF" @select="navSelect"
        :default-active="currentNav">
        <template v-for="item in $store.state.menu.menuList">
          <template v-if="!item.subMenu">
            <el-menu-item :index="item.key" :key="item.key">
              <i :class="item.icon" aria-hidden="true" class="menuIcon"></i>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>
          </template>
          <template v-else>
            <el-submenu :index="item.key" :key="item.key" v-if="item.subMenu.length > 0">
              <template slot="title">
                <i :class="item.icon" aria-hidden="true" class="menuIcon"></i>
                <span>{{ item.title }}</span>
              </template>
              <template v-for="subItem in item.subMenu">
                <el-menu-item v-if="!subItem.subMenu" :index="subItem.key" :key="subItem.key">
                  {{ subItem.title }}
                </el-menu-item>
                <el-submenu v-else :index="subItem.key" :key="key">
                  <template slot="title">{{ subItem.title }}</template>
                  <el-menu-item v-for="trdItem in subItem.subMenu" :index="trdItem.key" :key="trdItem.key">
                    {{ trdItem.title }}
                  </el-menu-item>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </div>
    <div class="main">
      <div class="header">
        <span class="userInfo">
          <i class="fa fa-user-circle-o" aria-hidden="true" style="margin: 0 0.5rem; font-size: 1rem"></i>
          <span>{{ userName }}</span>
          <span class="separator">|</span>
          <span>{{ $store.state.userInfo.worksiteName }}</span>
          <span class="separator">|</span>
          <span>{{ $store.getters["userInfo/role"] }}</span>
          <span class="separator">|</span>
          <el-button type="text" @click="updatePassword">修改密码</el-button>
          <span class="separator">|</span>
          <el-button type="text" @click="logout">退出</el-button>
        </span>
      </div>
      <div class="content">
        <el-tabs v-model="currentTab" type="card" @tab-remove="removeTab">
          <el-tab-pane v-for="item in $store.state.tabs.list" :closable="item.name !== 'welcome'" :key="item.name"
            :label="item.title" :name="item.name" :style="{ 'max-height': paneHeight + 'px' }" style="overflow: auto">
            <component :is="item.component" :ref="item.name" :params="item.params" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <update-password-dialog ref="updPswDialog" />
  </div>
</template>

<script>
import menuConfig from "@/config/menu";
import axios from "axios";
import UpdatePasswordDialog from "./UpdatePasswordDialog";
export default {
  data() {
    return {
      isNavCollapse: false,
      currentTab: "",
      paneHeight: 0,
      buildedMenus: [
        {
          icon: 'fa fa-envira',
          title: '首页',
          key: 'welcome',
          component: () => import( /* webpackChunkName: "pages" */ '@/views/welcome/Welcome')
        }, {
          icon: "fa fa-cogs",
          key: "keyBase",
          title: "基础资料",
          subMenu: []
        }, {
          icon: "fa fa-university",
          key: "keyShop",
          title: "店铺管理",
          subMenu: []
        }, {
          icon: "fa fa-diamond",
          key: "keyActive",
          title: "活动管理",
          subMenu: []
        }, {
          icon: "fa fa-bar-chart",
          key: "keyManage",
          title: "营运相关",
          subMenu: []
        }, {
          icon: "fa fa-money",
          key: "keyMoney",
          title: "费用收益",
          subMenu: []
        }, {
          icon: "fa fa-truck",
          key: "keyExpress",
          title: "快递业务",
          subMenu: []
        }, {
          icon: "fa fa-coffee",
          key: "keyWaimaiBox",
          title: "柜机管理",
          subMenu: []
        }
      ]
    };
  },
  created() {
    let userInfo = "";
    try {
      userInfo = JSON.parse(this.$cookies.get("user"));
    } catch (err) {
      // do nothing
    }
    if (!userInfo) {
      this.$router.replace({
        name: "login"
      });
      return;
    } else {
      this.$store.commit("userInfo/update", {
        user: userInfo
      });
      axios.defaults.headers["Authorization"] = "Bearer " + userInfo.token;
    }

    let permissionMenu = this.filterMenu(menuConfig.mainMenu);
    this.buildMenusHandle(permissionMenu);
    this.$store.commit("menu/update", {
      menuList: this.buildedMenus
    });
    if (this.buildedMenus.length > 0) {
      this.navSelect(this.buildedMenus[0].key);
    }
  },
  mounted() {
    this.calculatePaneHeight();
    window.addEventListener("resize", this.calculatePaneHeight);
  },
  methods: {
    navSelect(index) {
      this.$store.dispatch("tabs/open", { name: index });
    },
    removeTab(targetTab) {
      this.$store.commit("tabs/remove", targetTab);
    },
    calculatePaneHeight() {
      const screenHeight = document.body.offsetHeight;
      const headerHeight = 48;
      const tabHeight = 41;
      const padHeight = 16;
      this.paneHeight = screenHeight - headerHeight - tabHeight - padHeight * 3;
    },
    logout() {
      this.$confirm("确定退出吗？", "提示", {
        type: "info"
      })
        .then(() => {
          this.$store.commit("tabs/removeAll");
          this.$cookies.remove("user");
          this.$router.replace({
            name: "login"
          });
        })
        .catch(() => {
          // do nothing
        });
    },
    updatePassword() {
      this.$refs.updPswDialog.show();
    },
    buildMenusHandle(menus) {
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i];
        if (menu.key == "welcome") {
          continue;
        } else {
          this.buildedMenus[menu.menuIndex].subMenu.push(menu);
        }
      }
    },
    filterMenu(menu) {
      if (this.$store.getters["userInfo/role"] === "超级管理员") {
        return menu;
      } else if (this.$store.getters["userInfo/role"] === "网点管理员") {
        let notAllowList = [
          "welcome",
          "wxMenu",
          "tagManage",
          "withdrawMoney",
          "wxnotice",
          "express2Send",
          "expressTakeIn",
          "paotuiOrder",
          "smsManage",
          "expressPrint"
        ];
        return menu.filter(item => !notAllowList.includes(item.key));
      } else if (this.$store.getters["userInfo/role"] === "外卖管理员") {
        let allowList = [
          "welcome",
          "clientManage",
          "websitesManage",
          "wmKindManage",
          "areaManage",
          "buildingManage",
          "shopManage",
          "goodsTypeManage",
          "goodsManage",
          "keywordManage",
          "sortManage",
          "guideManage",
          "carouselManage",
          "activeManage",
          "lotteryManage",
          "shareQuanManage",
          "advManage",
          "scrollManage",
          "shareManage",
          "quanPoolManage",
          "liveOrderManage",
          "qishouManage",
          "serviceManage",
          "activeDepositManage",
          "sendMsgManage",
          "wxAdvTipsManage",
          "jintiePoolManage",
          "maskShopManage",
          "userApplyManage",
          "userShareQuanManage",
          "shopEarn"
        ];
        return menu.filter(item => allowList.includes(item.key));
      } else if (this.$store.getters["userInfo/role"] === "外卖运营管理") {
        let allowList = [
          "welcome",
          "clientManage",
          "websitesManage",
          "wmKindManage",
          "areaManage",
          "buildingManage",
          "shopManage",
          "goodsTypeManage",
          "goodsManage",
          "keywordManage",
          "sortManage",
          "guideManage",
          "carouselManage",
          "activeManage",
          "lotteryManage",
          "shareQuanManage",
          "advManage",
          "scrollManage",
          "shareManage",
          "quanPoolManage",
          "liveOrderManage",
          "qishouManage",
          "serviceManage",
          "activeDepositManage",
          "sendMsgManage",
          "wxAdvTipsManage",
          "jintiePoolManage",
          "maskShopManage",
          "userApplyManage",
          "userShareQuanManage",
          "shopEarn"
        ];
        return menu.filter(item => allowList.includes(item.key));
      } else if (this.$store.getters["userInfo/role"] === "外卖客服") {
        let allowList = [
          "welcome",
          "liveOrderManage",
          "qishouManage",
          "serviceManage"
        ];
        return menu.filter(item => allowList.includes(item.key));
      } else if (this.$store.getters["userInfo/role"] === "外卖柜运营管理") {
        let allowList = [
          "welcome",
          "wmTougui",
          "wmBalanceSite",
          "wmBalanceBox",
          "wmChargeActivity"
        ];
        return menu.filter(item => allowList.includes(item.key));
      } else if (this.$store.getters["userInfo/role"] === "普通员工") {
        let allowList = [
          "welcome",
          "express2Send",
          "expressTakeIn",
          "paotuiOrder",
          "smsManage",
          "expressPrint"
        ];
        return menu.filter(item => allowList.includes(item.key));
      }
    }
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.nameZH || "未登录";
    },
    currentNav() {
      return this.currentTab.split("@")[0];
    }
  },
  watch: {
    "$store.state.tabs.currentTab"(val) {
      this.currentTab = val;
    },
    currentTab(val) {
      if (val !== this.$store.state.tabs.currentTab) {
        this.$store.commit("tabs/updateCurrent", val);
      }
    }
  },
  components: {
    UpdatePasswordDialog
  }
};
</script>

<style scoped>
.menuIcon {
  font-size: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
}

.container {
  display: flex;
  height: 100%;
}

.sideNav {
  width: 200px;
  min-width: 200px;
  height: 100%;
  background-color: #2e3d4c;
  overflow-y: scroll;
  overflow-x: hidden;
}

.sideNav .el-menu {
  border-right: none;
}

.main {
  flex-grow: 1;
  overflow: hidden;
}

.header {
  height: 3rem;
  line-height: 3rem;
  box-shadow: 0px 2px 5px #dddddd;
  padding: 0 1rem;
}

.header>.userInfo {
  float: right;
  font-size: 0.8rem;
}

.content {
  padding: 1rem;
}

.separator {
  margin: 0 0.5rem;
  color: #dcdfe6;
}

.logo {
  border-bottom: 1px solid #909399;
}

.logo>img {
  width: 100%;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue